import React from "react";
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function Card(props) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.15,
  });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 28 }}
      animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : 28 }}
      transition={{ duration: 0.55, ease: "easeOut" }}
      className="w-full lg:w-4/5 mx-auto mt-8 rounded-2xl overflow-hidden bg-white shadow-md hover:shadow-xl transition-shadow duration-300 border border-gray-100"
    >
      <div className="flex flex-col md:flex-row min-h-[240px]">

        {/* ── Left: Cover image with gradient title overlay ── */}
        <div className="relative md:w-2/5 lg:w-1/3 flex-shrink-0 min-h-[220px] md:min-h-0 overflow-hidden">
          <img
            src={props.img}
            alt={props.title}
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-lime-950/90 via-lime-900/25 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <Link to={props.lesson}>
              <h3 className="font-dancing text-3xl font-bold text-white tracking-tight leading-tight hover:underline underline-offset-2 decoration-lime-400">
                {props.title}
              </h3>
            </Link>
          </div>
        </div>

        {/* ── Right: Thumbnails + description + CTA ── */}
        <div className="flex-1 bg-gradient-to-br from-amber-50 to-[#f0e8d8] p-6 flex flex-col justify-between gap-4">

          {/* Preview thumbnails */}
          <div className="flex gap-2 items-start">
            {[props.imgCard1, props.imgCard2, props.imgCard3].map((img, i) => (
              <img
                key={i}
                src={img}
                alt=""
                className="flex-1 min-w-0 w-0 h-auto rounded-lg hover:scale-105 transition-transform duration-300"
              />
            ))}
          </div>

          {/* Description */}
          <p className="text-gray-600 text-sm font-Inter leading-relaxed line-clamp-3">
            {props.description}
          </p>

          {/* CTA */}
          <div className="flex justify-end">
            <Link to={props.lesson}>
              <button className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium font-Inter text-white bg-lime-700 rounded-lg hover:bg-lime-800 active:bg-lime-900 transition-colors duration-200 shadow-sm">
                View Gallery
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </Link>
          </div>

        </div>
      </div>
    </motion.div>
  );
}
